import { prop, curry, compose } from 'ramda';

import { splash } from '../helpers/compact';
import { defaultPager } from '../reducers/paginations';
import { getDocsByIds } from './entities';
import { getLocale } from './i18n';

export const getPagers = prop('paginations');

/**
 * Simple function to provide default values when pager is undefined;
 *
 * @param {undefined|Pager} pager
 * @return {Pager}
 */
export const ensurePager = (pager = defaultPager) => pager;

/**
 * Return all pagers for the current user's language from the given state
 * @param {Object} state
 */
export const getLocalizedPagers = (state) =>
  compose(prop(getLocale(state)), getPagers)(state);

/**
 * Curried function to return the given pager for the state
 * (pager is localized with the users's language).
 *
 * @param {string} key
 * @param {Object} state
 * @return {Pager}
 */
export const getPager = curry((key, state) =>
  compose(ensurePager, prop(key), getLocalizedPagers)(state)
);

export const getFullResults = curry((pager, state) =>
  compose(getDocsByIds(state), splash, prop('result'))(pager)
);
